module.exports = __webpack_public_path__ + "static/img/7.7488ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/13/01/7.png
// module id = 2WEp
// module chunks = 2